/**
 * Trạng thái sắp xếp
 */
export default {
  /**
   * Không sort
   */
  none: 0,
  /**
   * Giảm dần
   */
  desc: 1,
  /**
   * Tăng dần
   */
  asc: 2,
};
